export const iplClusterTree = `cricket
+-- ipl
    +-- schedule
    |   +-- match pages
    |   +-- playoff schedule
    |   +-- season archives
    +-- points-table
    |   +-- team pages
    |   +-- playoff qualification
    |   +-- net run rate explained
    +-- results
    |   +-- scorecards
    |   +-- match highlights
    |   +-- player of the match
    +-- stats
    |   +-- batting records
    |   +-- bowling records
    |   +-- fielding records
    |   +-- team records
    |   +-- partnership records
    +-- winners-list
    |   +-- season finals
    |   +-- champion teams
    |   +-- player of the series
    +-- teams
        +-- chennai-super-kings
        |   +-- players
        |   +-- records
        |   +-- finals
        +-- mumbai-indians
        |   +-- players
        |   +-- records
        |   +-- finals
        +-- royal-challengers-bangalore
        |   +-- players
        |   +-- records
        +-- kolkata-knight-riders
        |   +-- players
        |   +-- records
        |   +-- finals
        +-- rajasthan-royals
        |   +-- players
        |   +-- records
        +-- sunrisers-hyderabad
        |   +-- players
        |   +-- records
        |   +-- finals
        +-- delhi-capitals
        |   +-- players
        |   +-- records
        +-- gujarat-titans
        |   +-- players
        |   +-- records
        |   +-- finals
        +-- lucknow-super-giants
        |   +-- players
        +-- punjab-kings
            +-- players
            +-- records`;

export const iplClusterNodes = [
  { title: "IPL Hub", to: "/cricket/ipl/" },
  { title: "Schedule", to: "/cricket/ipl/schedule/" },
  { title: "2026 Season", to: "/cricket/ipl/seasons/2026/" },
  { title: "2026 Tracker", to: "/cricket/ipl/seasons/2026/" },
  { title: "2025 Review", to: "/cricket/ipl/seasons/2025/" },
  { title: "2024 Review", to: "/cricket/ipl/seasons/2024/" },
  { title: "Points Table", to: "/cricket/ipl/points-table/" },
  { title: "2025 Final", to: "/cricket/ipl/seasons/2025/final/" },
  { title: "Stats", to: "/cricket/ipl/stats/" },
  { title: "Winners List", to: "/cricket/ipl/winners-list/" },
  { title: "RCB", to: "/cricket/ipl/teams/royal-challengers-bangalore/" },
  { title: "2025 Final", to: "/cricket/ipl/seasons/2025/final/" },
  { title: "2024 Final", to: "/cricket/ipl/seasons/2024/final/" },
  { title: "2023 Final", to: "/cricket/ipl/seasons/2023/final/" },
  { title: "Qualifier 1 2025", to: "/cricket/ipl/seasons/2025/qualifier-1/" },
  { title: "Qualifier 2 2025", to: "/cricket/ipl/seasons/2025/qualifier-2/" },
  { title: "Records", to: "/cricket/ipl/records/" },
];
